module.exports = __webpack_public_path__ + "img/A27216_E9D036_D0AB24_DCB927-256px.cb2e3889.png";